import { render, staticRenderFns } from "./MobileSettings.vue?vue&type=template&id=5c45f24c&scoped=true&"
import script from "./MobileSettings.vue?vue&type=script&lang=js&"
export * from "./MobileSettings.vue?vue&type=script&lang=js&"
import style0 from "./MobileSettings.vue?vue&type=style&index=0&id=5c45f24c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c45f24c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VContainer,VIcon,VImg,VList,VListItem,VListItemGroup,VListItemIcon,VListItemTitle})
